import InputFieldContainer, { InputFieldContainerProps } from '../common/InputFieldContainer';
import { useMemo, useState } from 'react';
import { GridCol, GridRow } from '@athena/forge';
import ProxyButton from '../common/ProxyButton';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { toPascalCase } from '../../utils/string-utils';
import { useEventBus } from '../../hooks/useEventBus';
import { useEnterKeyListener } from './ListenerHelper';
import Header from '../common/Header';
import { useWidgetContext } from '../context/WidgetContext';
import { I18N_MAPPING } from '../../constants';

export default function SmsPhoneInputSection(props: InputFieldContainerProps) {
  const [ disableResendCodeButton, setDisableResendCodeButton ] = useState<boolean>(true);
  const [ showResendButton, setShowResendButton ] = useState<boolean>(false);
  const { eventEmitter } = useWidgetContext();

  useEventBus({
    eventName: 'able_to_resend_otp',
    onEvent: ({ ableToResend }: { ableToResend: boolean }) => {
      setDisableResendCodeButton(!ableToResend);

      // If this event is received, that would mean SMS was sent successfully, so, update the description
      eventEmitter.emitEventToComponent({
        componentName: Header.displayName as string,
        eventName: 'update-header-description',
        eventPayload: { headerDescription: I18N_MAPPING['en']['oie.phone.verify.sms.codeSentText.without.phone'] },
      });
    },
  });

  useEventBus({
    eventName: 'enrolled_phone_changed',
    onEvent: () => {
      setShowResendButton((prevState) => !prevState);
    },
  });

  const [ sendCodeButton, resendCodeButton ] = useMemo(() => {
    const buttons = jQueryCourage('a.sms-request-button');
    return [ buttons.eq(0), buttons.eq(1) ];
  }, []);

  useEnterKeyListener(sendCodeButton, showResendButton);

  return (
    <div>
      <GridRow>
        <GridCol width={{ small: showResendButton ? 6 : 12 }}>
          <InputFieldContainer {...props}></InputFieldContainer>
        </GridCol>
        {showResendButton && (
          <GridCol width={{ small: 6 }}>
            <div className="fe_u_flex-container">
              <ProxyButton
                className="resend-code-button"
                oktaButton={resendCodeButton}
                variant="secondary"
                fullWidth
                size="medium"
                disabled={disableResendCodeButton}
                alwaysShow
                onClick={() => {
                  const resendCodeButtonText = resendCodeButton?.text() ? resendCodeButton.text() : 'Resend code';
                  emitOnClickAmplitudeEvent(resendCodeButtonText);
                }}
              />
            </div>
          </GridCol>
        )}
      </GridRow>
      {!showResendButton && (
        <ProxyButton
          oktaButton={sendCodeButton}
          variant="primary"
          fullWidth
          size="large"
          className="fe_u_margin--top-medium fe_u_margin--bottom-medium"
          alwaysShow
          onClick={() => {
            const sendCodeButtonText = sendCodeButton?.text() ? sendCodeButton.text() : 'Send code';
            emitOnClickAmplitudeEvent(sendCodeButtonText);
          }}
        />
      )}
    </div>
  );
}

function emitOnClickAmplitudeEvent(buttonText: string) {
  AmplitudeUtils.logMfaEnrollEvent(`SMS::${toPascalCase(buttonText)}ButtonClick`);
}
